export default __webpack_public_path__ + "static/media/GymTonicStandSpeed.b98fd88f.png";